var React = require('react');

function TickIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.7113134,0.205912081 C14.0610637,0.510110341 14.0982372,1.04048218 13.7942542,1.39053319 L6.31809078,10 L0.348032315,5.68724111 C-0.0277094733,5.41582482 -0.112428999,4.89089331 0.158787402,4.51487074 C0.430013795,4.13884817 0.954479422,4.05404308 1.33021122,4.32545937 L6.05707709,7.74026435 L12.5276583,0.288907063 C12.8315414,-0.0611339494 13.361563,-0.0982961802 13.7113134,0.205912081 Z","fill":"#FFF","fillRule":"evenodd"}));
}

TickIcon.defaultProps = {"viewBox":"0 0 14 10"};

module.exports = TickIcon;

TickIcon.default = TickIcon;
